import { render, staticRenderFns } from "./leave-case-manage-resolve.vue?vue&type=template&id=099aa8a0&scoped=true"
import script from "./leave-case-manage-resolve.vue?vue&type=script&lang=ts"
export * from "./leave-case-manage-resolve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099aa8a0",
  null
  
)

export default component.exports